const isArbitraryObject = (data) => typeof data === 'object' && data !== null;

export { isArbitraryObject };
